import { Component, Input, Output, EventEmitter, HostListener } from '@angular/core';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';

const TIMER_INTERVAL_START = 800;
const TIMER_INTERVAL_WORKING_MAX = 200;
const TIMER_INTERVAL_WORKING_MIN = 100;

@Component({
  selector: 'app-count-button',
  templateUrl: 'count-button.component.html',
  styleUrls: ['count-button.component.scss'],
})
export class CountButtonComponent {
  @Input() disabled: boolean;
  @Input() cssClass = 'fa fa-caret-up';
  // @Input() touchPadding = true;
  @Output() singleClick: EventEmitter<any> = new EventEmitter<any>();
  private count = 0;
  private timeoutHandler: any;
  private timerInterval: number;

  @Input() faIcon: IconDefinition;

  constructor() {
  }

  onButtonClick() {
    this.singleClick.emit();
  }

  @HostListener('mouseup')
  @HostListener('mouseleave')
  mouseup() {
    if (this.timeoutHandler) {
      clearTimeout(this.timeoutHandler);
      this.timeoutHandler = null;
    }
  }

  @HostListener('mousedown', ['$event'])
  mousedown() {
    this.resetTimerInterval();
    this.startTimer();
  }

  private resetTimerInterval() {
    this.timerInterval = TIMER_INTERVAL_START;
    this.count = 0;
  }

  private setTimerInterval() {
    const step = this.count ** 2;
    const decrement = step < TIMER_INTERVAL_WORKING_MIN ? step : TIMER_INTERVAL_WORKING_MIN;
    this.timerInterval = TIMER_INTERVAL_WORKING_MAX - decrement;
  }

  private startTimer() {
    const scope = this;
    this.timeoutHandler = setTimeout(() => {
      if (scope.timeoutHandler) {
        scope.count++;
        scope.setTimerInterval();
        scope.onButtonClick();
        scope.startTimer();
      }
    }, scope.timerInterval);
  }
}
